import { http } from './http'
import {
  EmailTemplateColor,
  EmailTemplateFooter,
  EmailTemplateFooterPayload,
  EmailTemplateHeader,
  EmailTemplateHeaderPayload,
  Template,
  ITemplates,
  Variable,
} from '../../common/models'

export const getEmailTemplateById = (id: string) =>
  http.get<Template>(`/operations/festivals/email/template/${id}`)

export const updateEmailTemplateById = (id: string, data: Template) =>
  http.put<Template>(`/operations/festivals/email/template/${id}`, data)

export const getEmailTemplateHeader = () =>
  http.get<EmailTemplateHeader>(`/operations/festivals/email/settings/header`)

export const updateEmailTemplateHeader = (data: EmailTemplateHeaderPayload) =>
  http.put<EmailTemplateHeader>(
    `/operations/festivals/email/settings/header`,
    data,
  )

export const getEmailTemplateFooter = () =>
  http.get<EmailTemplateFooter>(`/operations/festivals/email/settings/footer`)

export const updateEmailTemplateFooter = (data: EmailTemplateFooterPayload) =>
  http.put<EmailTemplateFooter>(
    `/operations/festivals/email/settings/footer`,
    data,
  )

export const getEmailTemplateColors = () =>
  http.get<EmailTemplateColor>(`/operations/festivals/email/settings/color`)

export const updateEmailTemplateColors = (data: EmailTemplateColor) =>
  http.put<EmailTemplateColor>(
    `/operations/festivals/email/settings/color`,
    data,
  )

export const getAllEmailTemplates = () =>
  http.get<ITemplates[]>('/operations/festivals/email/template')

export const getAllEmailTemplateVariables = (id: string) =>
  http.get<Variable[]>(`/operations/festivals/email/template/${id}/variable`)

export const getPreviews = (id: string) =>
  http.get<Variable[]>(`/operations/festivals/email/template/${id}/preview`)
